import {SectorIcon} from "../SectorIcon";

import "./SectorButton.css";

interface IProps {
  sector?: number;
  active?: boolean;
  solid?: boolean;
  onClick: () => void;
}
export const SectorButton = ({sector = 0, active, solid, onClick}: IProps) => {
  return (
    <button className={`sector-button${active?" active":""}`} onClick={onClick}>
      <SectorIcon sector={sector} solid={solid} />
    </button>
  )
}
